import React from "react";
import { Outlet } from "react-router-dom";
import FooterSection from "../components/FooterSection";
import HeaderSection from "../components/HeaderSection";
import ToastComponent from "../components/ToastComponent";

// Redux
import { Provider } from 'react-redux';
import store from "../stores/store";

function LayoutPage() {

	return (
		<Provider store={store}>
			<ToastComponent />
			<HeaderSection />
			<main>
				<Outlet />
			</main>
			<FooterSection />
		</Provider>
	);
}

export default LayoutPage;

